// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import DynamicDropdown, { OptionObject } from "@store/MobiusOverrides/DynamicDropdown/DynamicDropdown";
import { useBunzlDispatch } from "@store/Framework/Store/Bunzl/BunzlReducer";

import React from "react";

const filterByOptions: OptionObject[] = [
    {
        optionValue: "all",
        optionText: translate("All"),
    },
    {
        optionText: translate("Has Product"),
        optionValue: "hasProduct",
    },
    {
        optionText: translate("Does Not Have Product"),
        optionValue: "doesNotHaveProduct",
    },
];
const BulkListFilterByDropDown = () => {
    const bunzlDispatch = useBunzlDispatch();
    const filterBy = useAppSelector(state => state.bunzl.pages.bulkLists.filterBy);
    const isProductSelected = !!useAppSelector(
        state => state.components.productSelector.selectedProductInfo?.productId,
    );

    const handleSelectedFilterByChange = (selectedFilterBy: string | undefined) => {
        bunzlDispatch({
            type: "Store/Pages/bulkLists/setFilterBy",
            filterBy: selectedFilterBy as "all" | "hasProduct" | "doesNotHaveProduct",
        });
    };
    return (
        <DynamicDropdown
            label={translate("Filter by Product On List")}
            selected={filterBy}
            disabled={!isProductSelected}
            onSelectionChange={handleSelectedFilterByChange}
            options={filterByOptions}
            data-test-id="bulk-list-filter-by-dropdown"
            data-test-selector="bulkList_filterByDropdown"
        />
    );
};

const widgetModule: WidgetModule = {
    component: BulkListFilterByDropDown,
    definition: {
        group: "Common",
        icon: "Filter",
    },
};

export default widgetModule;
